import React, { useContext, useEffect, useState } from "react";
import "./Label.scss";
import Input from "@components/input/Input";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import MessageServices from "@services/MessageServices";
import Button from "@components/button/Button";
import ReactLoading from "react-loading";
import DropDownList from "@components/dropDownList/DropDownList";
import EndPointServices from "@services/ApiServices";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";

export default function Label(props) {
  //State Padrões
  const [state, dispatch] = useContext(GlobalContext);

  const [lstOrdem, setLstOrdem] = useState([]);
  const [showCriar, setShowCriar] = useState([]);

  //Input
  const [addLst, setAddLst] = useState([]);

  //DropList
  const [loadingDropLst, setLoadingDropLst] = useState(false);
  const [dropLst, setDropLst] = useState([]);

  useEffect(() => {
    if (props.lstLabel.length > 0) {
      handleMapLst();
    }
  }, [props.lstLabel]); // Adicionado para reexecutar se `lstLabel` mudar

  useEffect(() => {
    handleComparaLst(); //verificar a lista para habilitar o botão salvar
  }, [lstOrdem]);

  useEffect(() => {
    if (showCriar.length > 0) {
      handleLstLabel(); //Carrega a lstLabel do dropdownlst
    }
  }, [showCriar]);

  function handleCopiarTexto(texto) {
    navigator.clipboard
      .writeText(texto)
      .then(() => MessageServices.ShowSuccess("Texto copiado."))
      .catch((err) => {
        MessageServices.ShowSuccess("Erro ao copiar.");
        console.error("Erro ao copiar:", err);
      });
  }
  function handleExcluirItem(categoriakey, key) {
    setLstOrdem((prevLstLabel) =>
      prevLstLabel.map((categoria) =>
        categoria.categoria === categoriakey
          ? {
              ...categoria,
              lst: categoria.lst.filter((item) => item?.key !== key),
            }
          : categoria,
      ),
    );
  }
  function handleMapLst() {
    const sortedList = props.lstLabel.map((categoria) => ({
      ...categoria,
      lst: [...categoria.lst].map((item, subIndex) => ({
        ...item,
        key: UtilServices.generateUUID(), // Adiciona uma chave única para cada item dentro da categoria
      })),
    }));

    setLstOrdem(sortedList);
  }
  function handleInput(key, e) {
    setLstOrdem((prevLstLabel) =>
      prevLstLabel.map((categoria) => ({
        ...categoria,
        lst: categoria.lst.map((item) =>
          item.key === key
            ? { ...item, valor: e } // Atualiza o valor
            : item,
        ),
      })),
    );
  }
  function handleComparaLst() {
    const listaComparar = props.lstLabel;
    let isDiferent = false; // Inicializa como falso

    // Obtém o tamanho total de itens em ambas as listas
    const totalItensLstOrdem = lstOrdem.reduce(
      (acc, cat) => acc + cat.lst.length,
      0,
    );
    const totalItensComparar = listaComparar.reduce(
      (acc, cat) => acc + cat.lst.length,
      0,
    );

    // Verifica se os tamanhos são diferentes
    if (totalItensLstOrdem !== totalItensComparar) {
      isDiferent = true;
    } else {
      // Se os tamanhos são iguais, verifica se há diferenças nos itens
      listaComparar.forEach((categoriaComparar) => {
        categoriaComparar.lst.forEach((itemComparar) => {
          const itemEncontrado = lstOrdem
            .flatMap((categoria) => categoria.lst) // Une todas as listas de categorias
            .find(
              (item) =>
                item.label === itemComparar.label &&
                item.valor === itemComparar.valor,
            );

          // Se o item não for encontrado, marca isDiferent como true
          if (!itemEncontrado) {
            isDiferent = true;
          }
        });
      });
    }

    // Habilita ou desabilita o botão salvar dependendo de isDiferent
    props.setDisabledSalvar(isDiferent ? false : true);
  }
  async function handleLstLabel() {
    setLoadingDropLst(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
    };

    try {
      var retornoapi = await EndPointServices.CAD_LabelConsultar_Config(data);
      if (retornoapi.Success) {
        setDropLst(retornoapi?.BaseReturn?.LstClasse);
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoadingDropLst(false);
  }
  //DropDownLst Change
  function handleAddlst(e, categoria) {
    setAddLst((prevData) => {
      const existe = prevData.some((item) => item.categoria === categoria);

      if (existe) {
        // Substitui o item existente
        return prevData.map((item) =>
          item.categoria === categoria ? { categoria, label: e } : item,
        );
      } else {
        // Adiciona um novo item se a categoria não existir
        return [...prevData, { categoria, label: e }];
      }
    });
  }
  function handleAddlstValue(categoria) {
    const label = addLst.find((item) => item.categoria === categoria)?.label;
    return label;
  }
  //Input Change
  function handleAddlst_Input(e, categoria) {
    const categoriaExiste = addLst.some((item) => item.categoria === categoria);
    if (!categoriaExiste) {
      MessageServices.ShowWarning(
        "Adicione um item da lista antes de atribuir um valor!",
      );
    }

    setAddLst((prevData) => {
      return prevData.map((item) => {
        if (item.categoria === categoria) {
          return {
            ...item,
            valor: e, // Adiciona ou substitui o valor
          };
        }
        return item;
      });
    });
  }
  function handleAddlstValue_Input(categoria) {
    const label = addLst.find((item) => item.categoria === categoria)?.valor;
    return label;
  }
  function handleSalvarAddlst(categoria) {
    // Criar uma cópia profunda da lista base para evitar modificar o original
    const listaAtualizada = lstOrdem.map((item) => ({
      ...item,
      lst: [...item.lst], // Garante que `lst` não seja modificado diretamente
    }));

    addLst.forEach((novoItem) => {
      // Verifica se o valor está vazio antes de continuar
      if (!novoItem?.valor) {
        MessageServices.ShowWarning("O valor não pode ser vazio!");
        return;
      }

      // Encontrar a categoria correspondente na lista base
      const categoriaExistente = listaAtualizada.find(
        (item) =>
          item?.categoria === novoItem?.categoria &&
          item?.categoria === categoria,
      );

      //DUPLICIDADES AO ADICIONAR.
      if (props.labelDuplicidade) {
        // Verifica se o valor da label e o idlabel já existe na lista
        const idlabelJaExiste = categoriaExistente.lst.some(
          (item) =>
            item?.valor === novoItem?.valor &&
            item.idLabel === novoItem.label.ID_Label,
        );

        if (idlabelJaExiste) {
          return MessageServices.ShowWarning(props.labelDuplicidadeTxt);
        }
      }

      // Criar um novo objeto para adicionar à categoria existente
      const novoDado = {
        idLabel: novoItem?.label?.ID_Label,
        label: novoItem?.label?.Label,
        valor: novoItem?.valor,
        key: UtilServices.generateUUID(), // Gera uma chave única
      };

      if (categoriaExistente) {
        // Se a categoria já existe, adiciona o novo item dentro de `lst`
        categoriaExistente.lst.push(novoDado);
      }
    });

    // Atualiza o estado com a nova lista
    setLstOrdem(listaAtualizada);
    //Exclui da lst
    setAddLst((prev) => prev.filter((e) => e.categoria !== categoria));
  }
  function handleLimparCampos(item) {
    if (item) {
      //Exclui da lst
      setShowCriar((prev) =>
        prev.filter((criacao) => criacao.categoria !== item?.categoria),
      );
      //Exclui da lst
      setAddLst((prev) => prev.filter((e) => e.categoria !== item?.categoria));

      return;
    }

    setShowCriar([]);
    setAddLst([]);
  }

  return (
    <div className="label">
      <Button
        theme="2"
        nome="Salvar"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        title="Salvar Alterações"
        onClick={() => {
          props.onSalvar(lstOrdem);
          handleLimparCampos();
        }}
        disabled={!(!props.disabledSalvar && props.permissoesSalvar)}
      />
      <ButtonIcon
        Refresh
        className="label-refresh"
        titleRefresh="Recarregar objetos"
        onRefresh={() => {
          handleMapLst();
          props.setDisabledSalvar(true);
        }}
      />
      {props.loading ? (
        <div
          className="label-loading"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReactLoading
            type={"spin"}
            color={"#c1abff"}
            height={"30px"}
            width={"30px"}
            className="loading"
          />
        </div>
      ) : (
        lstOrdem?.map((item, index) => (
          <div key={index} className="label-lst">
            <p className="label-categoria">{item.categoria}:</p>
            <ul>
              {item.lst.map((subItem, subIndex) => (
                <li key={subIndex} className="label-item">
                  <p className="label-key">{subItem.label}:</p>
                  <Input
                    value={subItem.valor}
                    theme="4"
                    onChange={(e) => handleInput(subItem?.key, e)}
                  />
                  <ButtonIcon
                    Copy
                    titleCopy="Copy"
                    onCopy={() => {
                      handleCopiarTexto(subItem.valor);
                    }}
                  />
                  <ButtonIcon
                    Excluir
                    titleExcluir="Excluir registro"
                    onExcluir={() => {
                      handleExcluirItem(item.categoria, subItem.key);
                      if (props.permissoesSalvar) {
                        props.setDisabledSalvar(false); //habilitar o botão salvar
                      }
                    }}
                    disabledExcluir={!props.permissoesExcluir}
                  />
                </li>
              ))}
              {showCriar?.some(
                (criacao) => criacao.categoria === item?.categoria,
              ) && (
                <div className="label-input-criar">
                  <DropDownList
                    placeholder="Selecione"
                    theme="3"
                    data={(dropLst || []).filter(
                      (e) => e?.Categoria === item?.categoria,
                    )}
                    dataKey="ID_Label"
                    textField="Label"
                    onChange={(e) => {
                      handleAddlst(e, item?.categoria);
                    }}
                    value={handleAddlstValue(item?.categoria)}
                  />
                  <Input
                    placeholder="Valor"
                    theme="4"
                    onChange={(e) => {
                      handleAddlst_Input(e, item?.categoria);
                    }}
                    value={handleAddlstValue_Input(item?.categoria)}
                  />
                </div>
              )}
              <div className="label-button-criar">
                {showCriar?.some(
                  (criacao) => criacao.categoria === item?.categoria,
                ) ? (
                  <ButtonIcon
                    Salvar
                    titleSalvar="Salvar registro"
                    onSalvar={() => {
                      handleSalvarAddlst(item?.categoria);
                    }}
                  />
                ) : (
                  <ButtonIcon
                    Criar
                    titleCriar="Criar um novo registro"
                    onCriar={() => {
                      setShowCriar((prev) => [
                        ...prev,
                        { categoria: item?.categoria },
                      ]);
                    }}
                    disabledCriar={!props.permissoesCriar}
                  />
                )}

                {showCriar?.some(
                  (criacao) => criacao.categoria === item?.categoria,
                ) && (
                  <ButtonIcon
                    Excluir
                    titleExcluir="Excluir campos de registro"
                    onExcluir={() => {
                      handleLimparCampos(item);
                    }}
                  />
                )}
              </div>
            </ul>
          </div>
        ))
      )}
    </div>
  );
}

Label.defaultProps = {
  lstLabel: [
    {
      categoria: "Senha",
      lst: [
        { label: "Login Ecac", valor: "kaique" },
        { label: "Senha Ecac", valor: "teste123" },
        { label: "Senha Web", valor: "iquito" },
      ],
    },
    {
      categoria: "Códigos",
      lst: [
        { label: "CNAE SECUNDARIO", valor: "12341234123" },
        { label: "Nire", valor: "kaique" },
        { label: "CNAE SECUNDARIO", valor: "123412334344123" },
        { label: "CNAE SECUNDARIO", valor: "123412334344123" },
      ],
    },
  ],
  loading: false,
  setLoading: () => null,
  onSalvar: () => null,
  permissoesExcluir: false,
  permissoesSalvar: false,
  permissoesCriar: false,
  //Duplicidades
  labelDuplicidade: false,
  labelDuplicidadeTxt: "",
  //BotãoSalvar
  disabledSalvar: true,
  setDisabledSalvar: () => null,
};
